import { render, staticRenderFns } from "./modal-with-close.mpx?vue&type=template&id=79f05922&isComponent&outputPath=components%2Fmodal-with-close843d41d4%2Findex"
import script from "./modal-with-close.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fmodal-with-close843d41d4%2Findex"
export * from "./modal-with-close.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fmodal-with-close843d41d4%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports